import { render } from "./Couriers.vue?vue&type=template&id=33d3461c&scoped=true&ts=true"
import script from "./Couriers.vue?vue&type=script&lang=ts"
export * from "./Couriers.vue?vue&type=script&lang=ts"

import "./Couriers.vue?vue&type=style&index=0&id=33d3461c&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d3461c"]])

export default __exports__